import { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

export default function ShopAside({ children }: Props) {
  return (
    <aside className="flex flex-col shrink-0 justify-between w-[15.625rem] pl-7.5 pr-5">
      {children}
    </aside>
  );
}
